"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Showcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const partners = [{
    name: "Precision Auto Parts"
  }, {
    name: "SteelCore Fabricators"
  }, {
    name: "SafetyGuard Systems"
  }, {
    name: "Maritime Hull Works"
  }, {
    name: "Global Metal Supply"
  }, {
    name: "Industrial Flow Tech"
  }, {
    name: "Heavy Duty Components"
  }, {
    name: "Advanced Alloy Group"
  }, {
    name: "Automotive Tier One"
  }, {
    name: "Shipyard Solutions"
  }, {
    name: "MetalForm Dynamics"
  }, {
    name: "Safety First Engineering"
  }];
  return;
}